import React, { createContext } from 'react';

const TwoDImagesContext = createContext();

export default TwoDImagesContext;